import { getStatusText } from "./orderStatus";
import { extractPaymentStatus, getPaymentStatusText } from "./paymentStatus";

export const USER_ORDER_SORT_OPTIONS = [
  { value: "created_desc", label: "תאריך – החדש ביותר" },
  { value: "created_asc", label: "תאריך – הישן ביותר" },
  { value: "id_desc", label: "מספר הזמנה – גבוה לנמוך" },
  { value: "id_asc", label: "מספר הזמנה – נמוך לגבוה" },
  { value: "recipient_asc", label: "שם מקבל – א-ת" },
  { value: "recipient_desc", label: "שם מקבל – ת-א" },
  { value: "address_asc", label: "כתובת משלוח – א-ת" },
  { value: "address_desc", label: "כתובת משלוח – ת-א" },
  { value: "paymentStatus_asc", label: "סטטוס תשלום – א-ת" },
  { value: "paymentStatus_desc", label: "סטטוס תשלום – ת-א" },
  { value: "status_asc", label: "סטטוס הזמנה – א-ת" },
  { value: "status_desc", label: "סטטוס הזמנה – ת-א" },
  { value: "amount_desc", label: "סכום – גבוה לנמוך" },
  { value: "amount_asc", label: "סכום – נמוך לגבוה" },
];

export const getOrderRecipientName = (order) =>
  String(order?.name || order?.CustomerName || "").trim();

export const getOrderAddress = (order) =>
  String(order?.address || order?.FullAddress || "").trim();

export const getDisplayOrderNumber = (order) => order?.orderNumber ?? "-";

export const compareOrderNumbers = (a, b) => {
  const aRaw = String(a?.orderNumber ?? a?.id ?? "");
  const bRaw = String(b?.orderNumber ?? b?.id ?? "");
  return aRaw.localeCompare(bRaw, "he", {
    numeric: true,
    sensitivity: "base",
  });
};

export const getOrderPaymentStatusKey = (order) => {
  const fromTransactions =
    Array.isArray(order?.transactions) && order.transactions.length
      ? extractPaymentStatus(order.transactions[0])
      : "";
  const raw =
    fromTransactions || order?.PaymentStatus || order?.payment?.status || "";
  return getPaymentStatusText(raw) || String(raw);
};

export const getOrderStatusKey = (order) =>
  getStatusText(order?.tenantStatus || order?.tenantBranchStatus || "");

export const getOrderAmount = (order) =>
  Number(order?.finalSum ?? order?.totalSum ?? order?.Payment ?? 0) || 0;

const ORDER_DATE_FIELDS = [
  "created",
  "createdAt",
  "created_at",
  "Created",
  "orderDate",
  "OrderDate",
  "PaymentDateTime",
];

export const getOrderCreatedValue = (order) => {
  for (const field of ORDER_DATE_FIELDS) {
    const value = order?.[field];
    if (!value) continue;
    const time = new Date(value).getTime();
    if (!Number.isNaN(time) && time > 0) return value;
  }
  return null;
};

export const getOrderCreatedTime = (order) => {
  const value = getOrderCreatedValue(order);
  return value ? new Date(value).getTime() : null;
};

export const sortUserOrders = (orders, sortKey = "created_desc") => {
  if (!Array.isArray(orders) || orders.length < 2) return orders ?? [];

  const parts = String(sortKey).split("_");
  const direction = parts[parts.length - 1];
  const field = parts.slice(0, -1).join("_");
  const multiplier = direction === "desc" ? -1 : 1;

  return [...orders].sort((a, b) => {
    let comparison = 0;

    switch (field) {
      case "created": {
        const aTime = getOrderCreatedTime(a);
        const bTime = getOrderCreatedTime(b);
        if (aTime == null && bTime == null) {
          return compareOrderNumbers(a, b) * multiplier;
        }
        if (aTime == null) return 1;
        if (bTime == null) return -1;
        comparison = aTime - bTime;
        break;
      }
      case "id":
        comparison = compareOrderNumbers(a, b);
        break;
      case "recipient":
        comparison = getOrderRecipientName(a).localeCompare(
          getOrderRecipientName(b),
          "he",
        );
        break;
      case "address":
        comparison = getOrderAddress(a).localeCompare(getOrderAddress(b), "he");
        break;
      case "paymentStatus":
        comparison = getOrderPaymentStatusKey(a).localeCompare(
          getOrderPaymentStatusKey(b),
          "he",
        );
        break;
      case "status":
        comparison = getOrderStatusKey(a).localeCompare(
          getOrderStatusKey(b),
          "he",
        );
        break;
      case "amount":
        comparison = getOrderAmount(a) - getOrderAmount(b);
        break;
      default:
        comparison = 0;
    }

    if (comparison === 0) {
      comparison = compareOrderNumbers(a, b);
    }

    return comparison * multiplier;
  });
};
